export default "__VITE_ASSET__eed9ff89__"